import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1057"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "图层_1" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.923 13.394c-2.531-.437-4.678-1.752-6.648-3.258a.164.164 0 0 0-.225.024l-.606.718a.167.167 0 0 0 .036.247c2.154 1.386 4.741 2.077 7.435 2.322l.008-.053zm-5.322-.549a.164.164 0 0 0-.206.071l-.315.562a.166.166 0 0 0 .096.24 29.374 29.374 0 0 0 8.167 1.247l-.003-.069c-2.443-.129-5.185-.99-7.739-2.051zm-1.496-9.2a1.218 1.218 0 1 0 0-2.435 1.218 1.218 0 0 0 0 2.435z",
    class: "st8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "m14.762 5.552-4.027.324c-.45.036-.888.16-1.291.365l-1.567.798-1.074-2.966c1.355-.921 2.4-1.764 2.817-3.127a.499.499 0 0 0-.331-.624.494.494 0 0 0-.624.331c-.381 1.239-1.459 1.956-3.092 3.04-.56.372-1.172.778-1.824 1.254-2.274 1.66-2.263 3.914-1.938 4.874a.498.498 0 0 0 .63.314.501.501 0 0 0 .318-.631c-.026-.081-.586-1.908 1.252-3.486l1.645 2.929c.274.486.746.828 1.292.937l2.488.496a2.04 2.04 0 0 1 1.163.689l2.161 2.576a.467.467 0 0 0 .47.154l.029-.007a.469.469 0 0 0 .305-.673L11.58 9.298a1.37 1.37 0 0 0-.847-.688l-.82-.229.312-.259c.362-.3.783-.522 1.235-.652l3.469-.998a.47.47 0 0 0-.167-.92z",
    class: "st8"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }